import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { Box } from '@leagueplatform/genesis-core';
import { IdCard } from '#components/id-card/id-card.component.tsx';

export const NODE_TYPE_ID_CARD = 'idCard';

type IdCardProps = {
  source: string;
  description?: string;
  aspectRatio?: string;
  type: 'url' | 'base64';
  printSelectorId?: string;
};

type IdCardNode = MasonryEngineNode<
  typeof NODE_TYPE_ID_CARD,
  IdCardProps,
  {},
  {}
>;

export type IdCardRendererProps = MasonryEngineNodeRendererProps<IdCardNode>;

export function IdCardRenderer({
  source,
  description,
  aspectRatio,
  type,
  printSelectorId,
}: IdCardRendererProps) {
  return (
    <Box data-print-card={printSelectorId}>
      <IdCard
        aspectRatio={aspectRatio}
        description={description}
        source={source}
        type={type}
      />
    </Box>
  );
}
